import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addPx } from "./utils";
export var _spacingDeprecated_ = {
  /** @deprecated Use **lounge** instead */
  compact: 4,
  /** @deprecated Use **club** instead */
  moderate: 8,
  /** @deprecated Use **hall** instead */
  medium: 12,
  /** @deprecated Use **auditorium** instead */
  normal: 16,
  /** @deprecated Use **amphitheatre** instead */
  expanded: 24,
  /** @deprecated Use **arena** instead */
  spacious: 32,
  /** @deprecated No direct replacement */
  giant: 40
};

// I haven't found a way to get the deprecation warnings to work properly alongside
// the addPx function, hence the following are set up in a static object
var spacingDeprecated = {
  /** @deprecated Use **lounge** instead */
  compact: "4px",
  /** @deprecated Use **club** instead */
  moderate: "8px",
  /** @deprecated Use **hall** instead */
  medium: "12px",
  /** @deprecated Use **auditorium** instead */
  normal: "16px",
  /** @deprecated Use **amphitheatre** instead */
  expanded: "24px",
  /** @deprecated Use **arena** instead */
  spacious: "32px",
  /** @deprecated No direct replacement */
  giant: "40px"
};
export var _spacing_ = _objectSpread({
  lounge: 4,
  club: 8,
  hall: 12,
  auditorium: 16,
  theatre: 20,
  amphitheatre: 24,
  arena: 32,
  stadium: 48,
  dome: 64,
  field: 88
}, _spacingDeprecated_);
export var spacing = _objectSpread(_objectSpread({}, addPx(_spacing_)), spacingDeprecated);
export var _grid_ = {
  gutter: {
    small: _spacing_.club,
    large: _spacing_.club,
    xLarge: _spacing_.auditorium,
    xxLarge: _spacing_.auditorium
  },
  margin: {
    small: _spacing_.auditorium,
    large: _spacing_.auditorium,
    xLarge: _spacing_.giant,
    xxLarge: _spacing_.giant
  }
};
export var grid = addPx(_grid_);